import { CSSProperties } from "@material-ui/core/styles/withStyles";

// styles
import { greys } from "@clockwise/web-commons/src/styles/color.styles";

export const container: CSSProperties = {};

export const travelTimeAddressContainer: CSSProperties = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  width: "100%",
};

export const travelTimeAddress: CSSProperties = {
  flexGrow: 1,
};

export const travelTimeButtonIcon = {
  htmlColor: greys.slate,
};

export const travelTimeButton = {
  style: {
    marginTop: 5,
  } as CSSProperties,
};

export const intro: CSSProperties = {
  color: greys.slate,
  fontSize: 14,
  lineHeight: 1.5,
  paddingTop: 10,
  paddingBottom: 15,
  paddingRight: 80,
};

export const styles = {
  container,
  intro,
  travelTimeButton,
  travelTimeButtonIcon,
  travelTimeAddress,
  travelTimeAddressContainer,
};
